export enum Roles {
  admin_edit_nomenclature = 'admin_edit_nomenclature',
  admin_edit_users = 'admin_edit_users',
  invoices_read = 'invoices_read',
  requests_create = 'requests_create',
  requests_update_state = 'requests_update_state',
  requests_update_state_manager = 'requests_update_state_manager',
  requests_view_all = 'requests_view_all',
  results_publish = 'results_publish',
  results_upload = 'results_upload',
  results_view = 'results_view',
  samples_update_state = 'samples_update_state'
}
